/* eslint-disable */
export default `<div id="firstUserJourneyPopup" class="grid grid--frame grid--aitems-center grid--align-center">
    <div class="card card--primary grid-col--xsmall-11 grid-col--small-9 grid-col--medium-7 grid-col--large-5">
        <div class="card__divider">
            <div class="grid grid--padded-medium">
                <div class="grid-col--xsmall-11">
                    <h3 class="-head3 -text-secondary-color-50"><%=
                        translator.translate('views.templates.firstTimeUserJourney.hr.header') %></h3>
                </div>
                <div class="grid-col--xsmall-1">
                    <a id="popupCloseButton" href="javascript: void(0);">
                        <i class="icon-x"></i>
                    </a>
                </div>
            </div>
        </div>

        <div class="card__section">

            <div class="grid grid--pull-padded-xsmall grid-col__rule--bottom--xsmall">
                <div class="grid-col grid-col--xsmall-6 grid-col--padded-xsmall grid-col__rule--right--xsmall">
                    <i class="todayraces-sprite"></i>
                    <span><%= translator.translate('views.templates.firstTimeUserJourney.hr.group1') %></span>
                </div>
                <div class="grid-col grid-col--xsmall-6 grid-col--padded-xsmall">
                    <i class="betwatch-sprite"></i>
                    <span><%= translator.translate('views.templates.firstTimeUserJourney.hr.group1desc') %></span>
                </div>
            </div>


            <div class="grid grid--pull-padded-xsmall">

                <div class="grid-col grid-col--xsmall-6 grid-col--padded-xsmall grid-col__rule--right--xsmall">
                    <i class="contextual-sprite"></i>
                    <span><%= translator.translate('views.templates.firstTimeUserJourney.hr.group2') %></span>
                </div>

                <div class="grid-col grid-col--xsmall-6 grid-col--padded-xsmall">
                    <i class="spotlight-sprite"></i>
                    <span><%= translator.translate('views.templates.firstTimeUserJourney.hr.group2desc') %></span>
                </div>

            </div>

            <div class="grid grid--align-center">
                <a id="popupMainButton" href="javascript:void(0);" class="btn btn--success btn--expand"><%=
                    translator.translate('views.templates.firstTimeUserJourney.hr.startBetting') %></a>
            </div>

        </div>
    </div>
</div>`;
